// https://docs.sourcepoint.com/hc/en-us/articles/19387918202131-IAB-purposes-GDPR-TCF
const ConsentCategory = {
    MeasureAdPerformance: 7,
};
export const GenericTCF = {
    isPresent: () => {
        return "__tcfapi" in window;
    },
    hasGrantedPermission: () => {
        if (!window.__tcfapi) {
            return false;
        }
        let data;
        window.__tcfapi("getTCData", 2, (tcData, success) => {
            if (success) {
                data = tcData;
            }
        });
        if (!data) {
            return false;
        }
        const consents = data.purpose.consents;
        return Boolean(consents[ConsentCategory.MeasureAdPerformance]);
    },
    onConsentChanged: (callback) => {
        if (!window.__tcfapi) {
            return;
        }
        window.__tcfapi("addEventListener", 2, callback);
    },
};
